import { Routes } from '@angular/router';

import { UserDetailsComponent } from './pages/user-details/containers/user-details.component';
import { QuoteCalculationComponent } from './pages/quote-calculation/containers/quote-calculation.component';
import { MedicalUnderwritingComponent } from './pages/medical-underwriting/container/medical-underwriting.component';
import { TestUIComponent } from './pages/test-ui-components/container/test-ui-component';
import { AfterApplyComponent } from './pages/after-apply/containers/after-apply.component';
import { HoMedicalUnderwrittingComponent } from './pages/medical-underwriting/container/HO/ho-medical-underwritting/ho-medical-underwritting.component';

import { CMSResolver } from './core/resolvers/cms.resolver';
import { HealthResolver } from './core/resolvers/healthAndLifestyle.resolver';
import { uiCompJsonResolver } from './shared/services/api-services/ui.comp.json.resolver';

export const appRoutes: Routes = [
    { path: '', redirectTo: 'home', pathMatch: 'full' },
    {
        path: '',
        component: UserDetailsComponent,
        children: [
            { path: '', redirectTo: 'home', pathMatch: 'full' },
            {
                path: 'home',
                loadChildren: () =>
                    import('./pages/user-details/user-details.routes').then(m => m.userDetailsRoutes),
                
            },
        ],
        resolve: { contentData: CMSResolver, uiCompJson: uiCompJsonResolver },
    },
    {
        path: '',
        component: QuoteCalculationComponent,
        children: [
            { path: '', redirectTo: 'quote', pathMatch: 'full' },
            {
                path: 'quote',
                loadChildren: () =>
                    import('./pages/quote-calculation/quote-calculation-route.routes').then(
                        (m) => m.quoteRoutes
                    ),
            },
        ],
        resolve: { contentData: CMSResolver },
    },
    {
        path: '',
        component: MedicalUnderwritingComponent,
        children: [
            { path: '', redirectTo: 'medical', pathMatch: 'full' },
            {
                path: 'home',
                loadChildren: () =>
                    import('./pages/medical-underwriting/medical-underwriting-routes').then(
                        (m) => m.userRoutes
                    ),
            },
        ],
        resolve: { healthData: HealthResolver, contentData: CMSResolver },
    },
    {
        path: '',
        component: HoMedicalUnderwrittingComponent,
        children: [
            { path: '', redirectTo: 'ho-underwriting', pathMatch: 'full' },
            {
                path: 'ho-underwriting',
                loadChildren: () =>
                    import('./pages/medical-underwriting/medical-underwriting-routes').then(
                        (m) => m.userRoutes
                    ),
            },
        ],
        resolve: { healthData: HealthResolver, contentData: CMSResolver },
    },
    {
        path: '',
        component: TestUIComponent,
        children: [
            { path: '', redirectTo: 'test', pathMatch: 'full' },
            {
                path: 'test',
                loadChildren: () =>
                    import('./pages/test-ui-components/test.module').then(
                        (m) => m.TestUIModule
                    ),
            },
        ],
        resolve: { healthData: HealthResolver, contentData: CMSResolver },
    },
    {
        path: '',
        component: AfterApplyComponent,
        children: [
            { path: '', redirectTo: 'apply', pathMatch: 'full' },
            {
                path: 'apply',
                loadChildren: () =>
                    import('./pages/after-apply/after-apply.routes').then(
                        (m) => m.userRoutes
                    ),
            },
        ],
        resolve: { contentData: CMSResolver },
    },
];